/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDeliverFeeOptionsVo
 */
export interface GetDeliverFeeOptionsVo {
    /**
     * 起始值：重量(kg)或CBM
     * @type {number}
     * @memberof GetDeliverFeeOptionsVo
     */
    startValue?: number;
    /**
     * 结束值
     * @type {number}
     * @memberof GetDeliverFeeOptionsVo
     */
    endValue?: number;
    /**
     * 步长
     * @type {number}
     * @memberof GetDeliverFeeOptionsVo
     */
    stepValue?: number;
    /**
     * 起始金额
     * @type {number}
     * @memberof GetDeliverFeeOptionsVo
     */
    startAmount?: number;
    /**
     * 每步递增金额
     * @type {number}
     * @memberof GetDeliverFeeOptionsVo
     */
    stepAmount?: number;
}

/**
 * Check if a given object implements the GetDeliverFeeOptionsVo interface.
 */
export function instanceOfGetDeliverFeeOptionsVo(value: object): value is GetDeliverFeeOptionsVo {
    return true;
}

export function GetDeliverFeeOptionsVoFromJSON(json: any): GetDeliverFeeOptionsVo {
    return GetDeliverFeeOptionsVoFromJSONTyped(json, false);
}

export function GetDeliverFeeOptionsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliverFeeOptionsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'startValue': json['startValue'] == null ? undefined : json['startValue'],
        'endValue': json['endValue'] == null ? undefined : json['endValue'],
        'stepValue': json['stepValue'] == null ? undefined : json['stepValue'],
        'startAmount': json['startAmount'] == null ? undefined : json['startAmount'],
        'stepAmount': json['stepAmount'] == null ? undefined : json['stepAmount'],
    };
}

export function GetDeliverFeeOptionsVoToJSON(json: any): GetDeliverFeeOptionsVo {
    return GetDeliverFeeOptionsVoToJSONTyped(json, false);
}

export function GetDeliverFeeOptionsVoToJSONTyped(value?: GetDeliverFeeOptionsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startValue': value['startValue'],
        'endValue': value['endValue'],
        'stepValue': value['stepValue'],
        'startAmount': value['startAmount'],
        'stepAmount': value['stepAmount'],
    };
}

